import { baseImageUrl, platform } from '../constants'

export const getPermissionImagePath = (browser: string, os: string): string => {
  const capitalize = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

  const imagePaths: { [key: string]: string } = {
    'mobile-Iphone-Chrome': `${baseImageUrl}/browsers_permission_images/mobile-ios-chrome.png`,
    'mobile-Iphone-Safari': `${baseImageUrl}/browsers_permission_images/mobile-ios-safari.png`,
    'mobile-Android-Chrome': `${baseImageUrl}/browsers_permission_images/mobile-android-chrome.png`,
    'mobile-Android-Firefox': `${baseImageUrl}/browsers_permission_images/mobile-android-firefox.png`,
    'mobile-Android-Edge': `${baseImageUrl}/browsers_permission_images/mobile-android-edge.png`,
    'mobile-Android-Samsung': `${baseImageUrl}/browsers_permission_images/mobile-android-samsung.png`,
    'desktop-Mac-Chrome': `${baseImageUrl}/browsers_permission_images/desktop-mac-chrome.png`,
    'desktop-Mac-Firefox': `${baseImageUrl}/browsers_permission_images/desktop-mac-firefox.png`,
    'desktop-Mac-Safari': `${baseImageUrl}/browsers_permission_images/desktop-mac-safari.png`,
    'desktop-Mac-Edge': `${baseImageUrl}/browsers_permission_images/desktop-mac-edge.png`,
    'desktop-Windows-Chrome': `${baseImageUrl}/browsers_permission_images/desktop-windows-chrome.png`,
    'desktop-Windows-Firefox': `${baseImageUrl}/browsers_permission_images/desktop-windows-firefox.png`,
    'desktop-Windows-Edge': `${baseImageUrl}/browsers_permission_images/desktop-windows-edge.png`,
  }

  const key = `${platform}-${capitalize(os)}-${capitalize(browser)}`
  return imagePaths[key] || 'No se encontro la imagen para este dispositivo'
}
